import React, { Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

// Lazy load for code splitting
const EncounterView = lazyWithRetry(() => import('./components/EncounterView'));

/**
 * Encounter Page
 *
 * Main entry point for viewing/editing encounters.
 * Uses lazy loading for code splitting.
 */
export const EncounterPage: React.FC = () => {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <EncounterView />
    </Suspense>
  );
};

export default EncounterPage;
